import gql from 'graphql-tag';
import { STATES } from '../constants/constants';

export const ALL_USERS_QUERY = gql`
  query AllUsersQuery($first: Int, $skip: Int) {
    allUsers(first: $first, skip: $skip) {
      id
      name
      Organization {
        name
        id
      }
    }
  }`;

export const ALL_DEVICE_TYPES_QUERY = gql`
query AllDeviceTypesQuery($first: Int, $skip: Int) {
  allDeviceTypes(first: $first, skip: $skip) {
    id
    value
    label
  }
}`;

export const ALL_CROP_TYPES_QUERY = gql`
query AllCropTypesQuery($first: Int, $skip: Int) {
  allCropTypes(first: $first, skip: $skip) {
    id
    value
    label
  }
}`;

export const HASH_ORGANIZATION_QUERY = gql`
  query AllOrganizationsQuery($hash: String) {
    allOrganizations(where: { hash: $hash}) {
      id
      name
      hash
    }
  }`;

export const SIGNIN_USER_MUTATION = gql`
  mutation signin($identity: String, $secret: String) {
    authenticate: authenticateUserWithPassword(email: $identity, password: $secret) {
      item {
        id
        __typename
      }
      token
      __typename
    }
  }`;

export const CREATE_ORGANIZATION_MUTATION = gql`
  mutation createOrganizationMutation($name: String, $hash: String) {
    createOrganization(
      data: {
        name: $name,
        hash: $hash
      }
    ) {
      id,
      name
    }
  }
`;

export const DISCONNECT_USER_FROM_ORGANIZATION_MUTATION = gql `
  mutation updateOrganizationMutation($orgId: ID!, $userId: ID!) {
    updateOrganization (
      id: $orgId,
      data: {
        User: {
          disconnect: {
            id: $userId
          }
        }
      }
    ) {
      id
    }
  }
`;

export const DISCONNECT_ORGANIZATION_FROM_USER_MUTATION = gql `
  mutation updateUserMutation($userId: ID!, $orgId: ID!) {
    updateUser (
      id: $userId,
      data: {
        Organization: {
          disconnect: {
            id: $orgId
          }
        }
      }
    ) {
      id
    }
  }
`;

export const CREATE_DEVICE_MUTATION = gql`
  mutation CreateDeviceMutation($deviceTypeId: ID!, $name: String!, $cropTypesIds:[CropTypeWhereUniqueInput], $area: Float $pumpFlow: Float, $length: Int, $orgId: ID!, $latitude: Float, $longitude: Float, $crop: String) {
    createDevice(
      data: {
        name: $name,
        pumpFlow: $pumpFlow,
        length: $length,
        area: $area,
        DeviceType: {
          connect: {
          id: $deviceTypeId
          }
        },
        Crops : {
          create: {
            name: $crop,
            CropType: {
              disconnectAll: true,
              connect: $cropTypesIds
            }
          }
        },
        Location : {
          create: {
            latitude: $latitude,
            longitude: $longitude
          }
        },
        Organization: {
          connect: {
            id: $orgId
          }
        }
      }
    ) {
      id
    }
  }
`;

export const CREATE_USER_MUTATION = gql`
  mutation CreateUserMutation($name: String!, $email: String!, $password: String!, $phone: String!) {
    createUser(
      data: {
        name: $name,
        email: $email,
        password: $password,
        phone: $phone
      }
    ) {
      id
    }

    authenticate: authenticateUserWithPassword(email: $email, password: $password) {
      item {
        id
        __typename
      }
      token
      __typename
    }
  }
`;

export const UPDATE_ORGANIZATION_MUTATION = gql`
  mutation updateOrganizationMutation($id: ID!, $name: String, $hash: String) {
    updateOrganization (
      id: $id,
      data: {
        name: $name,
        hash: $hash
      }
    ) {
      id
      name
      hash
    }
  }
`;

export const USER_QUERY = gql`
  query UserQuery($id: ID!) {
    User (
      where: {id: $id}
    ) {
      id
      name
      email
      phone
      Role {
        id
        value
        label
      }
      Organization {
        id
        name
        hash
        User {
          id,
          name
        }
        Admin {
          id,
          name
        }
        Device {
          id,
          name,
          Event{
            id,
            name,
            State {
              id
              value
              label
            }
          },
          Crops {
            id,
            name
          }
        }
      }
      isAdmin
    }
  }
`;

export const DEMO_QUERY = gql`
  query DemoOrgQuery {
    Organization (
      where: {id: 999}
    ){
      id
      name
      Device {
        id,
        name,
        Event{
          id,
          name,
          State {
            id
          }
        },
        Crops {
          id,
          name
        }
      }
    }
  }
`;

export const DEVICE_DETAIL_QUERY = gql`
  query DeviceQuery($id: ID!) {
    Device (
      where: {id: $id}
    ) {
        id
        name
        area
        Organization{
          id
          name
        }
        Crops{
          id
          name
        }
        Location {
          id
          latitude
          longitude
        }
        Event {
          id
          dateTime
          sheet
          Location {
            id,
            latitude,
            longitude
          }
          angle
          pressure
          direction
          FailType {
            id
            value
            label
          }
          ProcessedState {
            id
          }
          State {
            id
            value
            label
          }
        }
        DeviceType {
          id
          value
          label
        }
        pumpFlow
        length
    }
  }
`;

export const ORGANIZATION_DEVICES_QUERY = gql`
  query OrganizationQuery($id: ID!) {
    Organization (
      where: {id: $id}
    ) {
        Device {
          id
        }
    }
  }
`;

export const DEVICES_FAILING_QUERY = gql`
  query AllDevicesQuery($first: Int, $skip: Int, $organizationIds: [Int]) {
    allDevices(first: $first, skip: $skip, where: {AND:[{Event: {State: {value: "${STATES.FAILURE}"}}}, {Organization: {id_in: $organizationIds}}]}) {
      id
      name
      DeviceType {
        id
        value
        label
      }
      Event {
        id
        FailType {
          id
          value
          label
        }
        State {
          id
          value
          label
        }
      }
      Crops {
        id
        name
      }
    }
  }`;

export const ALL_DEVICES_TIMELINE_QUERY = gql`
  query AllEventsQuery($first: Int, $skip: Int, $datetime: DateTime, $organizationIds: [Int]) {
    allEvents(first: $first, skip: $skip, where: {AND:[{dateTime_gte: $datetime}, {Device: {Organization: {id_in: $organizationIds}}}]}) {
      id
      dateTime
      name
      note
      sheet
      angle
      pressure
      FailType {
        id
        value
        label
      }
      State {
        id
        value
        label
      }
      Device {
        id
        name
        DeviceType {
          id
          value
          label
        }
      }
    }
  }
`;

export const UPDATE_USER_MUTATION = gql`
  mutation updateUserMutation($id: ID!, $name: String, $email: String, $phone: String) {
    updateUser (
      id: $id,
      data: {
        name: $name
        email: $email
        phone: $phone
      }
    ) {
      id
    }
  }
`;

export const UPDATE_USER_ORGANIZATION_MUTATION = gql`
  mutation updateUserMutation($userId: ID!, $orgId: ID!) {
    updateUser (
      id: $userId
      data: {
        Organization: {
          connect: {
            id: $orgId
          }
        }
      }
    ) {
      id
      Organization {
        id
        name
        User {
          id,
          name
        }
      }
    }

    updateOrganization (
      id: $orgId
      data: {
        User: {
          connect: {
            id: $userId
          }
        }
      }
    ) {
      id
      User {
        id
        name
      }
    }
  }
`;

export const UPDATE_USER_ROLE_MUTATION = gql`
  mutation updateUserMutation($userId: ID!, $roleId: ID!) {
    updateUser (
      id: $userId
      data: {
        Role: {
          connect: {
            id: $roleId
          }
        }
      }
    ) {
      id
      Organization {
        id
        name
      }
    }
  }
`;

export const UPDATE_DEVICE_ORGANIZATION_MUTATION = gql`
  mutation updateOrganizationMutation($deviceId: ID!, $orgId: ID!) {
    updateOrganization (
      id: $orgId
      data: {
        Device: {
          connect: {
            id: $deviceId
          }
        }
      }
    ) {
      id
      Device {
        id
        name
      }
    }
  }
`;

export const UPDATE_ORGANIZATION__ADMIN_MUTATION = gql`
  mutation updateOrganizationMutation($orgId: ID!, $userId: ID!) {
    updateOrganization (
      id: $orgId
      data: {
        Admin: {
          disconnectAll: true,
          connect: {
            id: $userId
          }
        }
      }
    ) {
      id
      Admin {
        id
        name
      }
    }
  }
`;

export const ALL_ROLES_QUERY = gql`
  query AllRolesQuery($first: Int, $skip: Int) {
    allRoles(first: $first, skip: $skip) {
      id
      value
      label
    }
  }
`;

export const DEVICE_TIMELINE_QUERY = gql`
  query EventQuery($id: Int) {
    allEvents (
      where: {Device: { id: $id}}
    ) {
        id
        dateTime
        name
        note
        sheet
        angle
        pressure
        direction
        FailType {
          id
          value
          label
        }
        State {
          id
          value
          label
        }
        Device {
          id
          name
        }
    }
  }
`;

export const ALL_STATES_QUERY = gql`
  query AllStatesQuery($first: Int, $skip: Int) {
    allStates(first: $first, skip: $skip) {
      id
      value
      label
    }
  }
`;

export const ALL_FAILTYPES_QUERY = gql`
  query AllFailTypesQuery($first: Int, $skip: Int) {
    allFailTypes(first: $first, skip: $skip) {
      id
      value
      label
    }
  }
`;

export const CREATE_EVENT_MUTATION = gql`
  mutation CreateEventMutation($dateTime: DateTime!, $direction: String, $name: String, $note: String, $sheet: Float, $angle: Float, $pressure: Float, $stateId: ID!, $deviceId: ID!, $latitude: Float, $longitude: Float) {
    createEvent(
      data: {
        dateTime: $dateTime,
        name: $name,
        note: $note,
        sheet: $sheet,
        angle: $angle,
        pressure: $pressure,
        direction: $direction,
        Location : {
          create: {
            latitude: $latitude,
            longitude: $longitude
          }
        },
        State: {
          connect: {
            id: $stateId
          }
        },
        Device: {
          connect: {
            id: $deviceId
          }
        }
      }
    ) {
      id
    }
  }
`;

export const CREATE_IRRIGATION_ORDER_MUTATION = gql`
  mutation CreateEventMutation($dateTime: DateTime!, $name: String, $note: String, $deviceId: ID!) {
    createEvent(
      data: {
        dateTime: $dateTime,
        name: $name,
        note: $note,
        Device: {
          connect: {
            id: $deviceId
          }
        }
      }
    ) {
      id
    }
  }
`;

export const UPDATE_FAILTYPE_EVENT_MUTATION = gql`
  mutation updateEventMutation($id: ID!, $failTypeId: ID!) {
    updateEvent (
      id: $id,
      data: {
        FailType: {
          connect: {
            id: $failTypeId
          }
        }
      }
    ) {
      id
    }
  }
`;

export const UPDATE_DEVICE_EVENT_MUTATION = gql`
  mutation updateDeviceMutation($id: ID!, $deviceId: ID!) {
    updateDevice (
      id: $deviceId,
      data: {
        Event: {
          connect: {
            id: $id
          }
        }
      }
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/constants/graphql.js